import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  selector: 'app-sms-logs',
  templateUrl: './sms-logs.component.html',
  styleUrls: ['./sms-logs.component.scss']
})
export class SmsLogsComponent implements OnInit {
  columnsToDisplay: any = ['firstName', 'lastName', 'telephone', 'message', 'success', 'action_date'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  isLoading: boolean;
  pageTitle = 'Αρχείο αποστολών sms από το eApply';
  searchDate: string;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(public toastMessagesService: ToastMessagesService,
              private commonService: CommonService) {
    this.isLoading = false;
    this.searchDate = '';
  }

  async ngOnInit(): Promise<void> {
    try {
      const request: any = await this.commonService.insertItem('messages/fetchSmsLogs', {actionDate: new Date()});
      const records = request.object;
      this.dataSource = new MatTableDataSource<any>(records);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.commonService.setPaginatorTexts(this.paginator);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Κάτι δεν πήγε καλά με την φόρτωση των δεδομένων');
    }
  }

  async search() {
    try {
      const value = this.searchDate;
      const request: any = await this.commonService.insertItem('messages/fetchSmsLogs', {actionDate: new Date(value)});
      const records = request.object;
      this.dataSource = new MatTableDataSource<any>(records);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Κάτι δεν πήγε καλά με την φόρτωση των δεδομένων');
    }
  }
}
